const imagesLoaded = require("imagesloaded");



const loderWarap = document.querySelector(".js-loader");
const loderInner = document.querySelector(".c-loading_inner");
// const progressBar = document.querySelector(".js-loader-progress-bar");
// const progressNumber = document.querySelector(".js-loader-progress-number");

const window_h = window.innerHeight;

const imgLoad = imagesLoaded("body"); //body内の画像を監視
const imgTotal = imgLoad.images.length; //画像の総数を取得

let imgLoaded = 0; //ロードした画像カウント
let progressSpeed = 8; //プログレスバーの進むスピード 大きいほど速くなる
let progressCount = 0; //ローディングの進捗状況 0〜100
let progressResult = 0; //ローディングの進捗状況 0〜100

//読み込み状況をアップデート
let progressInit = setInterval(function () {
  updateProgress();
}, 25);

loderWarap.style.height = window_h + "px";

loderInner.classList.add("is-active");
// $('.top-loader__inner').fadeIn();

//画像を一つロードするたびにimgLoadedのカウントをアップ
imgLoad.on("progress", function (instance, image) {
  imgLoaded++;
});

//読み込み状況アップデート関数
function updateProgress() {
  //ローディング演出用の計算
  progressCount += (imgLoaded / imgTotal) * progressSpeed;

  if (progressCount >= 100 && imgTotal > imgLoaded) {
    //カウントは100以上だが画像の読み込みが終わってない
    progressResult = 99;
  } else if (progressCount > 99.9) {
    //カウントが100以上になった
    progressResult = 100;
  } else {
    //現在のカウント
    progressResult = progressCount;
  }

  //ローディング進捗状況をプログレスバーと数字で表示
  // progressBar.style.width = progressResult + "%";
  // progressNumber.innerText = Math.floor(progressResult);

  //ローディング完了後 0.8秒待ってページを表示
  if (progressResult >= 100 && imgTotal == imgLoaded) {
    clearInterval(progressInit);
    setTimeout(function () {
      document.querySelector("body").classList.add("is-loaded");
    }, 800);
  }
}

//上のコメントを外すとローディングが有効になります。

// const images = $(".top-loader-image li").length;

//時間で画像とiconが切り替わる

const imgs = document.getElementsByClassName("top-loader-image__rotate");
let imgIndex = -1;

// function changeTxt() {
//   imgIndex++;

//   let currentNum = imgIndex % imgs.length;
//   let nextNum = (imgIndex + 1) % imgs.length;
//   let current = imgs[currentNum];
//   let next = imgs[nextNum];


//   setTimeout(function () {
//     current.classList.remove("is-active");
//   }, 2000);
//   setTimeout(function () {
//     next.classList.add("is-active");
//   }, 2400);
// }
// function showNextTxt() {
//   setInterval(changeTxt, 2500);
// }
// changeTxt();
// document.addEventListener("DOMContentLoaded", showNextTxt, false);
